module.exports = __webpack_public_path__ + "img/icon4.92110e61.png";